// src/api/axios.ts
import axios, { AxiosError, AxiosResponse } from 'axios';
import { toast } from 'react-toastify';

axios.defaults.baseURL =
  process.env.REACT_APP_API_URL || 'http://localhost:7000/api';

axios.defaults.withCredentials = true;

const responseBody = (response: AxiosResponse) => response.data;

axios.interceptors.response.use(
  async (response) => {
    return response;
  },
  (error: AxiosError) => {
    const { data, status } = (error.response as AxiosResponse) || {};

    switch (status) {
      case 400:
        toast.error((data as any)?.title || 'Bad Request');
        break;
      case 401:
        toast.error('Unauthorized');
        break;
      case 403:
        toast.error('Forbidden');
        break;
      case 404:
        console.error('Not Found');
        break;
      case 500:
        console.error('Server Error');
        break;
      default:
        console.error('Unexpected Error');
        break;
    }

    return Promise.reject(error);
  }
);

const requests = {
  get: (url: string, params?: Record<string, any>) =>
    axios.get(url, { params }).then(responseBody),
  post: (url: string, body: object) => axios.post(url, body).then(responseBody),
  put: (url: string, body: object) => axios.put(url, body).then(responseBody),
  del: (url: string) => axios.delete(url).then(responseBody),
};

const Business = {
  register: (registerData: any) =>
    requests.post('business/register', registerData),
  confirmPayment: (payload: {
    businessId: string;
    subscriptionId: string;
    customerId: string;
    paymentMethodId: string;
  }) => requests.post('business/confirm-payment', payload),
  getStatus: (businessId: string) =>
    requests.get(`business/status/${businessId}`),
  getSession: (sessionId: string) =>
    requests.get(`business/session/${sessionId}`),
};

const Subscriptions = {
  get: () => requests.get('subscriptions'),
  getById: (id: string) => requests.get(`subscriptions/${id}`),
};

const agent = {
  Business,
  Subscriptions,
};

export default agent;
